module.exports = __webpack_public_path__ + "img/a3.db749df8.jpg";